// src/constants/onboardingMethod.ts

export const ONBOARDING_METHODS = {
  CVL_KRA: 'CVL_KRA',
  CKYC: 'CKYC',
} as const;

export type OnboardingMethod = typeof ONBOARDING_METHODS[keyof typeof ONBOARDING_METHODS];

/**
 * Single toggle point for which onboarding method is active per fund flow direction.
 * Flip either value here to switch between CVL-KRA fetch (PAN + DOB) and
 * CKYC-based onboarding (PAN + mobile) — no component logic needs to change.
 *
 * e.g. to move outbound back to CVL-KRA temporarily:
 *   OUTBOUND: ONBOARDING_METHODS.CVL_KRA,
 */
export const FUND_FLOW_ONBOARDING_METHOD: Record<'INBOUND' | 'OUTBOUND', OnboardingMethod> = {
  INBOUND: ONBOARDING_METHODS.CVL_KRA,
  OUTBOUND: ONBOARDING_METHODS.CKYC,
};

export const getOnboardingMethod = (isOutbound: boolean): OnboardingMethod =>
  isOutbound ? FUND_FLOW_ONBOARDING_METHOD.OUTBOUND : FUND_FLOW_ONBOARDING_METHOD.INBOUND;
